import { useEffect, useState } from 'react';

export function useCycledIndex(length: number, dwellMs: number, active = true) {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    if (!active) return;
    const interval = setInterval(
      () => setIndex((current) => (current + 1) % length),
      dwellMs
    );
    return () => clearInterval(interval);
  }, [active, dwellMs, length]);

  return index;
}
